<ion-content class="demooz_list">
        
    @if(this.withSearch){
        <form class="demooz_list_search ion-padding-horizontal" [formGroup]="this.searchForm">
            <ion-grid class="no_padding">
                <ion-row class="ion-align-items-center">
                    <ion-col class="no_padding">
                        <demooz-input type="text" label="{{'MAIN.SEARCH' | translate}}" icon="search-outline" formName="search" [showBtnClearInput]="true" />                    
                    </ion-col>
                    @if(this.multiple){
                        <ion-col class="no_padding" size="auto">
                            @if(this.allSelected){
                                <demooz-button type="button" label="{{'MAIN.UNSELECT_ALL' | translate}}" color="primary" (click)="this.unselectAll()" />
                            }
                            @else{
                                <demooz-button type="button" label="{{'MAIN.SELECT_ALL' | translate}}" color="primary" (click)="this.selectAll()" />
                            }
                        </ion-col>
                    }
                </ion-row>
            </ion-grid>
        </form>
    }
         
    <div class="ion-padding-horizontal">    
        
        @if(this.isFetching){
            <div class="bloc_loading">
                <ion-spinner></ion-spinner>
            </div>        
        }
        @else{
            
            @if(this.itemsDisplayed.length === 0){        
                <demooz-message type="info">{{'MAIN.MSG_NO_DATA' | translate}}</demooz-message>       
            }
            @else{               
                @for(item of this.itemsDisplayed; track $index){
                    <demooz-item (click)="this.selectItem(item)">
                        <div class="item_list">
                            @if(item.picture){
                                <ion-avatar slot="start">
                                    <img [src]="item.picture" />
                                </ion-avatar>
                            }
                            
                            @if(this.displayItemsColors){
                                <div class="item_color" [class]="item.color"></div>
                            }
                            <ion-label>{{item.label}}</ion-label>  
                            
                            @if(this.itemsSelectedCopy.get(item.value)){
                                <ion-icon class="icon_item_checked" name="checkmark-outline"></ion-icon>
                            }
                        </div>
                    </demooz-item>            
                }
                
                <ion-infinite-scroll (ionInfinite)="this.onIonInfinite($event)" [disabled]="this.disabledInfiniteScroll">
                    <ion-infinite-scroll-content loading-spinner="dots"></ion-infinite-scroll-content>
                </ion-infinite-scroll> 
            }

        }
    </div>
</ion-content>
